<template>
  <div style="display: inline">
    <v-btn @click.stop="dialog = true"
           icon
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <EditLocationsForm
        v-if="dialog"
        :location="location"
        :showSuccess="showSuccess"
        :showFailure="showFailure"
        :connection="connection"
        @cancel="dialog = false"
        @ok="dialog = false"
        @locations-updated="
          $emit('locations-updated', $event)
        "
        @failure="$emit('failure', $event)"
      >
      </EditLocationsForm>
    </v-dialog>
  </div>
</template>

<script>
import EditLocationsForm from "./EditLocationsForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "EditLocations",
  components: { EditLocationsForm },
  props:      {
    connection:    HubConnection,
    location:      Object,
    showSuccess:   Function,
    showFailure:   Function,
    dialogTrigger: Boolean
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog(){
      this.dialog = true;
    }
  }
};
</script>

<style scoped></style>
